import api from "@/plugins/axios";
import Company from "@/models/company";
import { Meta, QueryParams } from "@/models/general";

const CompanyAPI = {
  async newCompany(payload: Company): Promise<Company | undefined> {
    return api.post("/companies", payload);
  },
  async getCompanies(
    params: QueryParams
  ): Promise<{ data: Company[]; meta: Meta }> {
    return api.get("/companies", {
      params: params,
    });
  },
  async getCompany(id: string): Promise<Company> {
    return api.get(`/companies/${id}`);
  },
  async updateCompany(payload: Company): Promise<Company | undefined> {
    return api.put(`/companies/${payload.id}`, payload);
  },
  async deleteCompany(id: string): Promise<void> {
    return api.delete(`/companies/${id}`);
  },
};

export default CompanyAPI;
